import { render, staticRenderFns } from "./specialIndex.vue?vue&type=template&id=c8f45832&scoped=true"
import script from "./specialIndex.vue?vue&type=script&lang=js"
export * from "./specialIndex.vue?vue&type=script&lang=js"
import style0 from "./specialIndex.vue?vue&type=style&index=0&id=c8f45832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f45832",
  null
  
)

export default component.exports